export const appleBillingManagementUrl =
  'https://apps.apple.com/account/subscriptions';
